/**
 * Instrument-profile registry (ADR-0012, FR-10).
 *
 * A profile isolates the few parameters that vary by instrument; everything else
 * (ragas, thaalams, JI math, lookup, UI) is shared. v1 implements `vocal`;
 * `saxophone` is registered as a scaffold (implemented: false).
 */
export const VOCAL_PROFILE = {
    id: 'vocal',
    // Range extends up to 1400 Hz so higher children's/female voices aren't clipped;
    // thresholds are lenient so quieter, breathier voices still register (paired with
    // the user-adjustable input gain in the engine).
    label: 'Vocal',
    pitchRange: { minHz: 70, maxHz: 1400 },
    presenceGate: 'formant-band-energy',
    mpm: { rmsThreshold: 0.004, clarityThreshold: 0.82 },
    implemented: true,
};
/** Scaffold only — parameters are placeholders until the saxophone profile is built out. */
export const SAXOPHONE_PROFILE = {
    id: 'saxophone',
    label: 'Carnatic Saxophone (coming soon)',
    pitchRange: { minHz: 140, maxHz: 1400 },
    presenceGate: 'broadband-energy-stability',
    mpm: { rmsThreshold: 0.01, clarityThreshold: 0.9 },
    implemented: false,
};
export const INSTRUMENT_PROFILES = {
    vocal: VOCAL_PROFILE,
    saxophone: SAXOPHONE_PROFILE,
};
export function getProfile(id) {
    return INSTRUMENT_PROFILES[id];
}
/** Profiles ready for real use (implemented === true). */
export function implementedProfiles() {
    return Object.values(INSTRUMENT_PROFILES).filter((p) => p.implemented);
}
//# sourceMappingURL=profiles.js.map